export default __webpack_public_path__ + "static/new_partner-d1fef577b7b8dbb0b7b8dfde41013224.jpg";